module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/Radio-8a7445d6e1d6afc063403aee1f73cdf571d68eae5db39cdd9619c3e31f3d3bdd.svg";